export const enum VestingTypeEnum {
  VESTING = 1,
  VESTING_HMC = 2,
  VESTING_VENTURE = 3,
  VESTING_HMC_V2 = 4,
  VESTING_VENTURE_V2 = 5,
}

export const enum AccountVestingTypeEnum {
  ACCOUNT_VESTING = 1,
  ACCOUNT_VESTING_HMC = 2,
  ACCOUNT_VESTING_VENTURE = 3,
  ACCOUNT_VESTING_HMC_V2 = 4,
  ACCOUNT_VESTING_VENTURE_V2 = 5,
}

export const ALLOCATION_TITLE: Record<number, string> = {
  [VestingTypeEnum.VESTING]: 'Allocation MEY',
  [VestingTypeEnum.VESTING_HMC]: 'Allocation HMC',
  [VestingTypeEnum.VESTING_VENTURE]: 'Allocation Venture',
  [VestingTypeEnum.VESTING_HMC_V2]: 'Allocation HMC V2',
  [VestingTypeEnum.VESTING_VENTURE_V2]: 'Allocation Venture V2',
}

export const enum AccountVestingStatusEnum {
  NEW = 1,
  GREATER = 2,
  LESS = 3,
  EQUAL = 4,
}

export const ACCOUNT_VESTING_STATUS_MAP: Record<number, { label: string; color: string }> = {
  1: { label: 'New', color: 'orange' },
  2: { label: 'Greater', color: 'blue' },
  3: { label: 'Less', color: 'red' },
  4: { label: 'Equal', color: 'green' },
}

export const ACCOUNT_VESTING_STATUS_OPTIONS = [
  { value: null, label: 'All Status' },
  { value: AccountVestingStatusEnum.NEW, label: 'New' },
  { value: AccountVestingStatusEnum.GREATER, label: 'Greater' },
  { value: AccountVestingStatusEnum.LESS, label: 'Less' },
  { value: AccountVestingStatusEnum.EQUAL, label: 'Equal' },
]

// V2 status enum (API returns 0-3)
export const enum AccountVestingStatusEnumV2 {
  EQUAL = 0,
  NEW = 1,
  CHANGE_SIGN_DATE = 2,
  CANCEL_CONTRACT = 3,
}

export const ACCOUNT_VESTING_STATUS_MAP_V2: Record<number, { label: string; color: string }> = {
  0: { label: 'Equal', color: 'green' },
  1: { label: 'New', color: 'orange' },
  2: { label: 'Change Sign Date', color: 'blue' },
  3: { label: 'Cancel Contract', color: 'red' },
}

export const ACCOUNT_VESTING_STATUS_OPTIONS_V2 = [
  { value: null, label: 'All Status' },
  { value: AccountVestingStatusEnumV2.EQUAL, label: 'Equal' },
  { value: AccountVestingStatusEnumV2.NEW, label: 'New' },
  { value: AccountVestingStatusEnumV2.CHANGE_SIGN_DATE, label: 'Change Sign Date' },
  { value: AccountVestingStatusEnumV2.CANCEL_CONTRACT, label: 'Cancel Contract' },
]
